/** sessionStorage key for last Hermes chat per account (browser-tab session). */
export function hermesLastChatStorageKey(accountId: string): string {
  return `hermes:lastChatId:${accountId}`;
}

export function readHermesLastChatId(accountId: string): number | null {
  if (!accountId || typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(hermesLastChatStorageKey(accountId));
    if (!raw) return null;
    const id = Number(raw);
    return Number.isFinite(id) && id > 0 ? id : null;
  } catch {
    return null;
  }
}

export function writeHermesLastChatId(accountId: string, chatId: number): void {
  if (!accountId || typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(hermesLastChatStorageKey(accountId), String(chatId));
  } catch {
    // Private mode / quota — in-memory chatId still works for this page session.
  }
}
